import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDocumentService } from '../../services/dynamic-document.service';
import { Personnemorale } from '../../entities/personnemorale';
import { catchError, firstValueFrom, map, Subscription } from 'rxjs';
import { Trame } from '../../entities/trame';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src-adisco/services/common.service';
import { UserService } from 'src/app/admin/core/services/user.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { EmailService } from '../../services/email.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

enum ImportType {
  PRODUIT = 'Produit',
  TARIF = 'Tarif'
}


export interface Trame2Validate {
  supplier: { documentName: string, documentId: string },
  frameType: { parameterId: string },
  trameName: string,
  frameRepository: string
}

export interface FrameValidation {
  nbLignesError: number,
  nbLignesTreated: number,
  nbLignesWarn: number,
  nbLignesOk: number,
  numberDepublished:number
  nbLignesIgnore: number,
  articlesWithoutTarifsInDatabase:[]
  records: {
    column: string,
    row: number,
    type: string,
    message: string,
    sheetname: string
  }[]
}

@Component({
  selector: 'app-frame-import',
  templateUrl: './frame-import.component.html',
  styleUrls: ['./frame-import.component.css']
})
export class FrameImportComponent implements OnInit, OnDestroy {
  private sideBar: boolean = true;
  private documentName = 'dynamic_workflow_product';
  private repositoryName = 'frame_module';
  protected isAdmin: boolean = false;
  email:string
  importTypeEnum = ImportType;
  selectedImportType: ImportType = ImportType.TARIF;
  suppliers: Personnemorale[] = [];
  selectedSupplier: Personnemorale;
  publicationDate?: Date;
  todayDate: Date;
  statusList: any[] = [];
  tramType: any;

  frame?: File; // Trame produits ou tarifs (FORMAT XLSX)
  docsFt: File[] = [];
  docsFds: File[] = [];
  docsCertif: File[] = [];
  pictures: File[] = [];

  frameUploadProgress: number = 0; // Progression de l'upload (0-100)
  frameUploadInProgress: boolean = false; // Indique si un upload est en cours
  frameUploadSubscription: Subscription; // Permet d'annuler l'upload

  picturesUploadProgress: number = 0;
  picturesUploadInProgress: boolean = false;
  picturesUploadSubscription: Subscription;

  docsUploadProgress: number = 0;
  docsUploadInProgress: boolean = false;
  docsUploadSubscription: Subscription;

  lockSupplier: boolean = false; // Cas d'un fournisseur
  uploadCompleted: boolean = false;
  submitted: boolean = false;

  importStats = {
    totalLines: 0,
    ignoredLines: 0,
    validLines: 0,
    alertLines: 0,
    errorLines: 0,
    nbDepublie:0,
    articlesWithoutTarifsInDatabase:[]

  }; // Données de statistiques
  reportDetails: string = ''; // Rapport détaillé ligne par ligne
  frameValidation: FrameValidation;
  frameToValidate: Trame2Validate;
  promises: Promise<boolean>[] = [];

  reportDone = false;

  currentDocument: Trame;

  get isProduct() {
    return this.selectedImportType == this.importTypeEnum.PRODUIT
  }

  get isValid() {
    return this.selectedSupplier &&
      this.frame &&
      this.publicationDate &&
      !this.frameUploadInProgress &&
      !this.picturesUploadInProgress &&
      !this.docsUploadInProgress &&
      !this.uploadCompleted;
  }

  get frameScanCompleted() {
    return this.frameUploadProgress == 100; // GET SCAN PROGRESS INSTEAD OF FRAMEUPLOADPROGRESS
  }

  get dateString(): string {
    return this.todayDate.toISOString().split('T')[0];
  }

  constructor(
    private dynamicDocumentService: DynamicDocumentService,
    private datePipe: DatePipe,
    private userService: UserService,
    private router: Router,
    private emailService: EmailService,
    private commonService: CommonService) {
    this.todayDate = new Date();
    this.todayDate.setHours(12);
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'token' && event.newValue === null) {
        this.router.navigate(['/login']);
      }
    });
    this.userService.getCurrentUser().then(user => {
       this.email = user.email;
    })
  }

  ngOnInit(): void {
    this.hideSearchBar();
    this.setHeaderBloc();
    this.loadSuppliers();
    this.loadStatus();
  }

  hideSearchBar() {
    let sideBarElement = document.getElementsByClassName('wrap-search-bar')[0];
    this.sideBar && sideBarElement ? sideBarElement.classList.add('hide-element') : (sideBarElement ? sideBarElement.classList.remove('hide-element') : null);
    this.sideBar = !this.sideBar;
  }

  setHeaderBloc() {
    let header = document.getElementById('header');
    let headerBloc = document.getElementById('header-bloc');
    if (headerBloc && header) {
      headerBloc.style.height = header.clientHeight.toString() + 'px';
      headerBloc.style.width = '10px';
    }
  }

  resetForm() {
    this.pictures = [];
    this.docsFt = [];
    this.docsFds = [];
    this.docsCertif = [];
    this.frame = undefined;
    this.publicationDate = undefined
  }

  loadSuppliers() {
    this.userService.getCurrentUser().then((res: any) => {
      if (res.linkToLegalEntity) { // Cas d'un fournisseur
        this.isAdmin = false;
        this.dynamicDocumentService.find(
          {
            collectionName: 'dynamic_natural_person',
            filters: [
              { fieldName: 'email', conditions: [{ type: 'EQUALS', value: res.email }] }
            ], // { fieldName: 'statusProduct', conditions: [{ type: 'EQUALS', value: 'VALIDE' }] }
            sorts: {},
            page: 1,
            pageSize: 9999999,
          }
        ).pipe(
          map(resp => {
            if (resp.content) {
              let naturalPerson = resp.content[0];
              this.dynamicDocumentService.findById('dynamic_legal_entity', naturalPerson.linkToLegalEntity.documentId).pipe(
                map(supplier => {
                  this.suppliers.push(supplier);
                  this.selectedSupplier = this.suppliers[0];
                  this.lockSupplier = true;
                })
              ).subscribe();
            }

          })
        ).subscribe();
      } else { // Cas d'un admin
        this.isAdmin = true;
        this.dynamicDocumentService.find({
          collectionName: 'dynamic_legal_entity',
          filters: [
            { fieldName: 'status', conditions: [{ type: 'EQUALS', value: 'Publié' }] },
            { fieldName: 'typeOfLegalEntity', conditions: [{ type: 'EQUALS', value: 'FOURNISSEUR' }] }
          ], // { fieldName: 'statusProduct', conditions: [{ type: 'EQUALS', value: 'VALIDE' }] }
          sorts: {},
          page: 1,
          pageSize: 9999999,
        }, true).subscribe((res: any) => {
          this.suppliers = res.content;
          this.suppliers.sort((a: Personnemorale, b: Personnemorale) => a.companyName.localeCompare(b.companyName))
        })
      }
    })
  }

  loadStatus() {
    this.commonService.getStatutWorkflow().pipe(
      map((res) => {
        this.statusList = res;
      })
    ).subscribe();
  }

  exportFile() {
    if (this.isProduct) {
      window.open(window.location.origin + '/assets/BASE-IMPORT-TRAME-ARTICLES.xlsx', '_blank')
    } else {
      window.open(window.location.origin + '/assets/BASE-IMPORT-TRAME-TARIFS.xlsx', '_blank')
    }
  }

  onPicturesLoad(event: any) {
    const files = event.target.files;
    if (files) {
      this.pictures = Array.from(files); // Convertit FileList en tableau
    }
  }

  onDocsFtLoad(event: any) {
    const files = event.target.files;
    if (files) {
      this.docsFt = Array.from(files); // Convertit FileList en tableau
    }
  }

  onDocsFdsLoad(event: any) {
    const files = event.target.files;
    if (files) {
      this.docsFds = Array.from(files); // Convertit FileList en tableau
    }
  }

  onDocsCertifLoad(event: any) {
    const files = event.target.files;
    if (files) {
      this.docsCertif = Array.from(files); // Convertit FileList en tableau
    }
  }

  onFrameLoad(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.frame = file; // Stocke directement le fichier
    }
  }

  async uploadFrame(file: File) {
    await this.getTramType();
    this.frameUploadInProgress = true;
    this.frameUploadProgress = 0;
    this.dynamicDocumentService.uploadFile(file, `${this.repositoryName}/upload-frame`, this.selectedSupplier.companyName).subscribe({
      next: (event: any) => {

        if (event.type === HttpEventType.UploadProgress) {
          this.frameUploadProgress = Math.round((100 * event.loaded) / event.total!);
        } else if (event.type === HttpEventType.Response) {
          let frameRepo = event.body.message;
          this.currentDocument.frameRepository = frameRepo;
          this.currentDocument.frameName = this.frame?.name;
          if (this.frame)
            this.frameToValidate = {
              frameRepository: frameRepo,
              frameType: this.tramType,
              supplier: { documentName: 'dynamic_legal_entity', documentId: this.selectedSupplier.id },
              trameName: this.frame.name
            };

          this.waitForResponsesThenGetRecord();
        }
      },
      error: (err) => console.error('Erreur lors de l\'upload de la trame:', err),
    });
  }

  async waitForResponsesThenGetRecord() {
    try {
      await Promise.all(this.promises);
      this.getRecord(this.frameToValidate);
    } catch (error) {
      console.log(error);
    }
  }


  getRecord(frameToValidate: Trame2Validate) {
    this.dynamicDocumentService.validateFrame(frameToValidate).subscribe((res) => {
    
      this.reportDone = true;
      this.frameValidation = res;
  
      // Update import stats
      this.importStats.totalLines = res.nbLignesTreated;
      this.importStats.ignoredLines = res.nbLignesIgnore;
      this.importStats.validLines = res.nbLignesOk;
      this.importStats.alertLines = res.nbLignesWarn;
      this.importStats.errorLines = res.nbLignesError;
      this.importStats.nbDepublie = res.numberDepublished;
      this.importStats.articlesWithoutTarifsInDatabase = Array.isArray(res.articlesWithoutTarifsInDatabase) ? res.articlesWithoutTarifsInDatabase : [];
  
      // 🕒 Delay to ensure DOM is ready (but consider moving this to Angular lifecycle hooks if possible)
      setTimeout(() => {
        const report = document.getElementById('report-bloc');
        if (report) {
          report.innerHTML = '';  // Clear previous report content
  
          // 🧾 Summary Section
  
          // 📄 Grouping records by sheetname
          const groupedBySheet: { [sheetname: string]: any[] } = {};
          if (res.records && Array.isArray(res.records)) {
            res.records.forEach(record => {
              if (record && record.type !== 'SUCCESS' && record.row && record.message) {
                if (!groupedBySheet[record.sheetname]) {
                  groupedBySheet[record.sheetname] = [];
                }
                groupedBySheet[record.sheetname].push(record);
              }
            });
  
            // 🧩 Output grouped logs by sheet
            Object.entries(groupedBySheet).forEach(([sheetname, records]) => {
              const sheetTitle = document.createElement('div');
              sheetTitle.classList.add('sheet-header', 'mt-3', 'fw-bold');
              sheetTitle.innerText = `Feuille: ${sheetname}`;
              report.appendChild(sheetTitle);
  
              records.forEach(record => {
                const recordNode = document.createElement('div');
                recordNode.classList.add(record.type.toLowerCase());
                if (record.type === 'WARNING') {
                  recordNode.classList.add('text-warning');
                } else if (record.type === 'ERROR') {
                  recordNode.classList.add('text-danger');
                }
  
                recordNode.innerText = `${record.row} - ${record.type} [${record.sheetname}${record.column ? ', colonne ' + record.column : ''}] ${record.message}`;
                report.appendChild(recordNode);
              });
  
              // Optional: Add spacing between sheets
              const spacer = document.createElement('div');
              spacer.style.marginBottom = '1rem';
              report.appendChild(spacer);
            });
          }

                    // 🧾 Additional log entries for articles without tariffs
                    if (this.importStats?.articlesWithoutTarifsInDatabase?.length) {
                      this.importStats.articlesWithoutTarifsInDatabase.forEach(article => {
                        const node = document.createElement('div');
                        node.classList.add('text-danger');
                        node.innerText = `L'article ${article} n'a pas de tarif.`;
                        report.appendChild(node);
                      });
                    }
  
          // Handle case with no records
          if (!res.records || res.records.length === 0) {
            const noData = document.createElement('div');
            noData.innerText = "La première feuille n'est pas valide, fichier à vérifier";
            report.appendChild(noData);
          }
  

        }
      }, 150);  // 150 ms delay to ensure the DOM is ready
    });
  }
  
  // getRecord(frameToValidate: Trame2Validate) {
  //   this.dynamicDocumentService.validateFrame(frameToValidate).subscribe((res) => {
  //     console.log(res);
  //     this.reportDone = true;
  //     this.frameValidation = res;
  
  //     // Update import stats
  //     this.importStats.totalLines = res.nbLignesTreated;
  //     this.importStats.ignoredLines = res.nbLignesIgnore;
  //     this.importStats.validLines = res.nbLignesOk;
  //     this.importStats.alertLines = res.nbLignesWarn;
  //     this.importStats.errorLines = res.nbLignesError;
  //     this.importStats.nbDepublie = res.numberDepublished;
  //     this.importStats.articlesWithoutTarifsInDatabase=res.articlesWithoutTarifsInDatabase;
  
  //     // 🕒 Delay to ensure DOM is ready
  //     setTimeout(() => {
  //       const report = document.getElementById('report-bloc');
  //       if (report) {
  //         report.innerHTML = '';
  
  //         // 🧾 Summary Section
        
          
  //         // 📄 Grouping records by sheetname
  //         const groupedBySheet: { [sheetname: string]: any[] } = {};
  //         res.records.forEach(record => {
  //           if (record && record.type !== 'SUCCESS' && record.row && record.message) {
  //             if (!groupedBySheet[record.sheetname]) {
  //               groupedBySheet[record.sheetname] = [];
  //             }
  //             groupedBySheet[record.sheetname].push(record);
  //           }
  //         });
  
  //         // 🧩 Output grouped logs by sheet
  //         Object.entries(groupedBySheet).forEach(([sheetname, records]) => {
  //           const sheetTitle = document.createElement('div');
  //           sheetTitle.classList.add('sheet-header', 'mt-3', 'fw-bold');
  //           sheetTitle.innerText = `Feuille: ${sheetname}`;
  //           report.appendChild(sheetTitle);
  
  //           records.forEach(record => {
  //             const recordNode = document.createElement('div');
  //             recordNode.classList.add(record.type.toLowerCase());
  //             if (record.type === 'WARNING') {
  //               recordNode.classList.add('text-warning');
  //             } else if (record.type === 'ERROR') {
  //               recordNode.classList.add('text-danger');
  //             }
  
  //             recordNode.innerText = `${record.row} - ${record.type} [${record.sheetname}${record.column ? ', colonne ' + record.column : ''}] ${record.message}`;
  //             report.appendChild(recordNode);
  //           });
  
  //           // Optional: Add spacing between sheets
  //           const spacer = document.createElement('div');
  //           spacer.style.marginBottom = '1rem';
  //           report.appendChild(spacer);
  //         });
  
  //         // Handle case with no records
  //         if (!res.records || res.records.length === 0) {
  //           const noData = document.createElement('div');
  //           noData.innerText = "La première feuille n'est pas valide, fichier à vérifier";
  //           report.appendChild(noData);
  //         }

  //         if (this.importStats?.articlesWithoutTarifsInDatabase?.length) {
  //           this.importStats.articlesWithoutTarifsInDatabase.forEach(article => {
  //             const node = document.createElement('div');
  //             node.classList.add('text-danger');
  //             node.innerText = `L'article ${article} n'a pas de tarif.`;
  //             report.appendChild(node);
  //           });
  //         }
  //       }
  //     }, 150);
  //   });
  // }
  

  // getRecord(frameToValidate: Trame2Validate) {
  //   this.dynamicDocumentService.validateFrame(frameToValidate).subscribe((res) => {
  //     console.log(res)
  //     this.reportDone = true;
  //     this.frameValidation = res;
  //     this.importStats.totalLines = res.nbLignesTreated;
  //     this.importStats.ignoredLines = res.nbLignesIgnore;
  //     this.importStats.validLines = res.nbLignesOk;
  //     this.importStats.alertLines = res.nbLignesWarn;
  //     this.importStats.errorLines = res.nbLignesError;
  //     this.importStats.nbDepublie = res.numberDepublished;

  //     setTimeout(() => {
  //       let report = document.getElementById('report-bloc');
  //       if (report) {
  //         report.innerHTML = '';
  //         res.records.forEach(record => {
  //           if (record && record.type !== 'SUCCESS' && record.row && record.message) {
  //             const node = document.createElement('div');
  //             node.classList.add(record.type.toLowerCase());
  //             node.classList.add(record.type == 'WARNING' ? 'text-warning' : (record.type == 'ERROR' ? 'text-danger' : ''));
  //             node.innerText = `${record.row} - ${record.type} [${record.sheetname}${record.column ? ', colonne ' + record.column : ''}] ${record.message}\n`;
  //             if (report) report.appendChild(node);
  //           }
  //         })
  //       }
  //     }, 150);
  //   })
  // }

  uploadPictures(files: File[]) {
    this.picturesUploadInProgress = true;
    this.picturesUploadProgress = 0;
    this.promises.push(this.picturesUploadPromise(files));
  }

  picturesUploadPromise(files: File[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.dynamicDocumentService.uploadMultipleFiles(files, `${this.repositoryName}/upload-pictures`, this.selectedSupplier.companyName,"PHOTO").subscribe({
        next: (event: any) => {

          if (event.type === HttpEventType.UploadProgress) {
            this.picturesUploadProgress = Math.round((100 * event.loaded) / event.total!);
          } else if (event.type === HttpEventType.Response) {
            this.currentDocument.picturesRepository = event.body.message;
            resolve(true);
          }
        },
        error: (err) => {
          console.error('Erreur lors de l\'upload des images:', err);
          reject(err);
        },
      });
    })
  }

  uploadDocs(files: File[], docType:any) {
    this.docsUploadInProgress = true;
    this.docsUploadProgress = 0;
    this.promises.push(this.docsUploadPromise(files,docType));
  }

  docsUploadPromise(files: File[],docType:any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.dynamicDocumentService.uploadMultipleFiles(files, `${this.repositoryName}/upload-docs`, this.selectedSupplier.companyName,docType).subscribe({
        next: (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.docsUploadProgress = Math.round((100 * event.loaded) / event.total!);
          } else if (event.type === HttpEventType.Response) {
            this.currentDocument.documentsRepository = event.body.message;
            resolve(true);
          }
        },
        error: (err) => {
          console.error('Erreur lors de l\'upload des documents:', err);
          reject(err);
        },
      });
    })
  }

  complete() {
    this.cancelUpload();
    this.uploadCompleted = true;
  }

  cancelUpload() {
    this.frameUploadInProgress = false;
    this.picturesUploadInProgress = false;
    this.docsUploadInProgress = false;
    this.frameUploadProgress = 0;
    this.picturesUploadProgress = 0;
    this.docsUploadProgress = 0;
  }

  downloadReport() {
    const content = this.formatFrameValidation(this.frameValidation);

    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `rapport-${this.frame?.name.split('.')[0]}.txt`;

    link.click();

    URL.revokeObjectURL(link.href);
  }

  private formatFrameValidation(frame: FrameValidation): string {
    let formatted = `Fournisseur : ${this.selectedSupplier.companyName || 'Fournisseur inconnu'}\n`;
    formatted += `Trame ${(this.currentDocument.frameType?.value?.includes('roduit') || this.currentDocument.frameType == 'Produit') ? 'Produit' : 'Tarif'}\n`;
    let date: any = this.currentDocument.submissionDate;
    formatted += `Date : ${new Date(date).toISOString()}\n\n`;
  
    formatted += `Nombre de lignes traîtées: ${frame.nbLignesTreated}\n`;
    formatted += `Nombre de lignes valides : ${frame.nbLignesOk}\n`;
    formatted += `Nombre d'articles dépubliés : ${frame.numberDepublished}\n`;
    formatted += `Nombre de lignes en erreur : ${frame.nbLignesError}\n`;
    formatted += `Nombre de lignes en alertes : ${frame.nbLignesWarn}\n\n`;

  
  
    const groupedBySheet = new Map<string, any[]>();
  
    frame.records.forEach((record) => {
      if (record && record.type !== 'SUCCESS' && record.row && record.message) {
        if (!groupedBySheet.has(record.sheetname)) {
          groupedBySheet.set(record.sheetname, []);
        }
        groupedBySheet.get(record.sheetname)!.push(record);
      }
    });
  
    groupedBySheet.forEach((records, sheetname) => {
      formatted += `Feuille: ${sheetname}\n`;
      records.forEach(record => {
        formatted += `${record.row} - ${record.type} [${record.sheetname}${record.column ? ', colonne ' + record.column : ''}] ${record.message}\n`;
      });
      formatted += `\n`; // Blank line between sheets
    });

    formatted += frame.articlesWithoutTarifsInDatabase
  .map(article => `L'article ${article} n'a pas de tarif.`)
  .join('\n') + '\n\n';

  
    return formatted;
  }
  

  // private formatFrameValidation(frame: FrameValidation): string {
  //   let formatted = `Fournisseur : ${this.selectedSupplier.companyName || 'Fournisseur inconnu'}\n`;
  //   formatted += `Trame ${(this.currentDocument.frameType?.value?.includes('roduit') || this.currentDocument.frameType == 'Produit') ? 'Produit' : 'Tarif'}\n`;
  //   let date: any = this.currentDocument.submissionDate;
  //   formatted += `Date : ${new Date(date).toISOString()}\n\n`;

  //   formatted += `Nombre de lignes traîtées: ${frame.nbLignesTreated}\n`;
  //   formatted += `Nombre de lignes valides : ${frame.nbLignesOk}\n`;
  //   formatted += `Nombre d'articles dépubliés : ${frame.numberDepublished}\n`;
  //   formatted += `Nombre de lignes en erreur : ${frame.nbLignesError}\n`;
  //   formatted += `Nombre de lignes en alertes : ${frame.nbLignesWarn}\n\n`;

  //   frame.records.forEach((record) => {
  //     if (record && record.type !== 'SUCCESS' && record.row && record.message) {
  //       formatted += `${record.row} - ${record.type} [${record.sheetname}${record.column ? ', colonne ' + record.column : ''}] ${record.message}\n`
  //     }
  //   });

  //   return formatted;

  // }

  submitForValidation() {
    this.uploadCompleted = false;
    // Envoyer une requête de changement de statut pour soumettre l'import
    this.currentDocument.userImported = this.email;
    this.dynamicDocumentService
      .saveDocument(this.documentName, this.currentDocument, true)
      .subscribe(() => {
        this.submitted = true;
        // SEND EMAIL
  
          
          // Prepare the file content
          const content = this.formatFrameValidation(this.frameValidation);
          const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
          const file = new File([blob], `rapport-${this.frame?.name.split('.')[0]}.txt`, { type: 'text/plain' });

          let message = `<div style="text-align:left; font-family: Roboto;">
          <h2 style="text-align:left">Une nouvelle trame a été importée :</h2>
            <div style="margin-top: 10px;"><strong>Fournisseur : </strong>${this.selectedSupplier.companyName}</div>
            <div style="margin-top: 10px;"><strong>Date de soumission : </strong>${this.currentDocument.submissionDate ? this.currentDocument.submissionDate.toLocaleString('fr-FR') : '-'}</div>
            <div style="margin-top: 10px;"><strong>Date de publication : </strong>${this.currentDocument.publicationDate ? this.currentDocument.publicationDate.toLocaleString('fr-FR') : '-'}</div>
        </div>`;

          let bodyContactMail: any = {
            mailsubject: `Trame ${this.isProduct? 'produits' : 'tarifs'} à valider`,
            mailfrom: this.email,
            mailto:environment.tramValidationMailList,
            tramValidationEmailTemplate:environment.tramValidationEmailTemplate,
            mailcontent: message,
          }

          // this.emailService.sendFrameValidationMail(email, this.currentDocument).pipe(
          this.emailService.sendMailWithAttachment(file).pipe(
            map(el => {
            
              if (el) {
                bodyContactMail.attachments = el;
                this.emailService.sendBasicMail(bodyContactMail).subscribe(resp => {
                
                });
              }
            }),
            catchError(err => {
              throw (err);
            })
          ).subscribe();
      

      });
  }

  async validate() {
    window.scrollTo({ top: 0 });
    this.submitted = false;
    await this.getTramType();
    this.currentDocument = {
      supplier: { documentName: 'dynamic_legal_entity', documentId: this.selectedSupplier.id },
      submissionDate: new Date,
      frameType: this.tramType,
      status: { parameterId: this.statusList.find(el => el.valeur == 'A_VALIDER')?.id },
      userImported:this.email
    };
    this.currentDocument.submissionDate = this.datePipe.transform(
      this.currentDocument.submissionDate,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
    this.currentDocument.publicationDate = this.datePipe.transform(
      this.publicationDate,
      "yyyy-MM-dd'T'HH:mm:ss"
    );

    if (this.frame) this.uploadFrame(this.frame);
    if (this.pictures.length > 0) this.uploadPictures(this.pictures);
    if (this.docsFt.length > 0) this.uploadDocs(this.docsFt,"FT");
    if (this.docsFds.length > 0) this.uploadDocs(this.docsFds,"FDS");
    if (this.docsCertif.length > 0) this.uploadDocs(this.docsCertif,"CERTIF");
  }

  async getTramType() {
    let frameTypeValue = this.isProduct ? "Produits" : "Tarifs";

    this.tramType = await firstValueFrom(this.commonService.getParametreByTableAndValue("FRAME_TYPE", frameTypeValue));
    this.tramType.value = this.tramType.valeur

  }

  ngOnDestroy(): void {
    this.hideSearchBar();
  }

}
